var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.17,
    height: 18.151,
    viewBox: "0 0 18.17 18.151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160658",
    "data-name": "Group 160658",
    transform: "translate(0.407 0.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160565",
    "data-name": "Group 160565",
    transform: "translate(-0.242 -0.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard_Outline_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1085",
    "data-name": "Rectangle 1085",
    width: 18,
    height: 18,
    transform: "translate(0 0)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1086",
    "data-name": "Rectangle 1086",
    width: 6.681,
    height: 6.681,
    rx: 1,
    transform: "translate(0.636 0.634)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1087",
    "data-name": "Rectangle 1087",
    width: 6.681,
    height: 6.681,
    rx: 1,
    transform: "translate(10.461 0.634)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.57
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1088",
    "data-name": "Rectangle 1088",
    width: 6.681,
    height: 6.681,
    rx: 1,
    transform: "translate(0.62 10.426)",
    fill: "none",
    stroke: "#787f88",
    strokeWidth: 1.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M22.02,15.48c.008.049.016.09.025.139",
    transform: "translate(-4.943 -3.744)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.57
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M20.616,19.044a1.571,1.571,0,0,1-1.736,1.515h-3.25A1.719,1.719,0,0,1,13.91,18.84v-3.25a1.719,1.719,0,0,1,1.719-1.719h3.25a1.729,1.729,0,0,1,1.629,1.163",
    transform: "translate(-3.473 -3.452)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 0.467,
    cy: 0.467,
    r: 0.467,
    transform: "translate(16.675 13.365)",
    fill: "#787f88"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardWhiteIcon);
export default __webpack_public_path__ + "static/media/dashboard-white-icon.0300e49aa2f22c290e9fe696a01b6487.svg";
export { ForwardRef as ReactComponent };